import Vue from 'vue'
import Router from 'vue-router'
import DealerForm from './components/DealerForm.vue'
import auth from './services/auth'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'DealerForm',
      component: DealerForm,
      meta: {
        requiresAuthentication: false
      }
    },
    { path: '*', redirect: '/' },
  ]
})

// Global route guard
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuthentication)) {
    // this route requires auth, check if logged in
    if (auth.user()) {
      next();
    } else {
      auth.login()
    }
  } else {
    next();
  }
});

export default router